import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const API_URL_NEW = process.env.REACT_APP_API_URL
console.log(localStorage.getItem('id'));

const partyId = localStorage.getItem('id')
console.log("you party id",partyId);
export const CHANGE_PASSWORD_URL = `${API_URL}/party/change-password`
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/party/login`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const RESENDOTP_SELLER_URL = `${API_URL_NEW}/resend-otp`
export const VERIFYOTP_SELLER_URL = `${API_URL_NEW}/otp-verify`
export const LOGOUT_URL = `${API_URL_NEW}/logout`
export const USER_URL = `${API_URL}/users`
export const NEW_LOGOUT_URL = `${API_URL_NEW}/party/logout`;
console.log("url",`${API_URL_NEW}/party/logout/${partyId}`);

// export const getNewLogoutUrl = () => {
//   const partyId = localStorage.getItem('id');
//   return `${API_URL_NEW}/logout/${partyId}`;
// };

// console.log(getNewLogoutUrl());
// if (partyId) {
//   const LOGOUT_URL = `${API_URL_NEW}/logout/${partyId}`;
//   console.log(partyId);
  
// }
// export const NEW_LOGOUT_URL = `${API_URL}/party/Logout`
// Server should return AuthModel


export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

export function resendOTP(whatsapp_number: string) {
  return axios.post<AuthModel>(RESENDOTP_SELLER_URL, {
    whatsapp_number,
  })
}

export function verifyOTP(token: string, otp: string) {
  return axios.post<AuthModel>(VERIFYOTP_SELLER_URL, {
    token,
    otp,
  })
}

export function loginNew(mobileno: string, password: string) {
  return axios.post<AuthModel>(`${API_URL_NEW}/party/login`, {
    mobileno,
    password,
  })
}

export function forgotPasswordApi(data: any) {
  return axios.post<any>(`${API_URL_NEW}/auth/forgot-password`, data).then((data: any) => data.data)
}

export function changePasswordApi(data: any) {
  return axios.post<any>(`${CHANGE_PASSWORD_URL}`, data).then((data: any) => data)
}

export function resetPasswordApi(data: any) {
  return axios.post<any>(`${API_URL_NEW}/auth/reset-password`, data).then((data: any) => data.data)
}

export function verifyotpApi(data: any) {
  return axios.post<any>(`${API_URL_NEW}/auth/check_2fa_code`, data).then((data: any) => data.data)
}

export function generate2faOTPApi(data: any) {
  return axios
    .post<any>(`${API_URL_NEW}/auth/generate_2fa_otp`, data)
    .then((data: any) => data.data)
}

export function setup2faApi(data: any) {
  return axios
    .post<any>(`${API_URL_NEW}/auth/verify_to_enable_2fa`, data)
    .then((data: any) => data.data)
}

export function disable2faApi(data: any) {
  return axios.post<any>(`${API_URL_NEW}/auth/disable_2fa`, data).then((data: any) => data.data)
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function logoutApi(partyId: any) {
  return axios.delete(`${NEW_LOGOUT_URL}/${partyId}`).then((response) => response.data)
}
export function fetchUserPermissionsApi(id: any) {
  return axios.get(`${USER_URL}/${id}`).then((response: any) => response.data)
}
